// New version src/Common/validators/data_validation.constant.ts DATA_VALIDATION
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/infinite_scroll_module.js DATA_VALIDATION

export const DATA_VALIDATION = {
	email: /^[^ @]+@[^ @]/,
};
